<template>
    <div class="ship">
        <el-dialog title="发货" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" plain>关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
        
    },
    props: {
      statue:{
        type: String,
        default:"0",
      }
    },
    filters: {},
    methods: {
        ...mapActions({
            getOrdersConsignmentsList: "commodity/getOrdersConsignmentsList",
            DeleteBeiOrderList:"commodity/DeleteBeiOrderList", //关闭北京接口
            ConfirmBeiOrderList:"commodity/ConfirmBeiOrderList" //确认北京收货接口
        }),
        handleClose() {
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.ship {
    .main {
        height: 520px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
    .select_goods {
        h3 {
            margin: 30px 0;
        }
    }
    .flex {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #e8e8e8;
    }
}
::v-deep .el-table__body-wrapper {
    max-height: 400px;
    overflow-y: auto;
}
</style>